import * as React from "react";
import {tokens, makeStyles, Button, Link} from "@fluentui/react-components";
import {useEffect} from "react";

const useStyles = makeStyles({
    footer: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        backgroundColor: tokens.colorNeutralBackground3,
        textAlign: "center",
        paddingTop: "12px",
        paddingBottom: "12px",
        paddingLeft: "12px",
        paddingRight: "12px",
        flexShrink: 0,
        overflowWrap: "anywhere",
        borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
    },
    link: {
        overflowWrap: "anywhere",
    }
});

const Header: React.FC = () => {
    const styles = useStyles();

    const [estConnecte, setEstConnecte] = React.useState(false);

    useEffect(() => {
        setEstConnecte(!!localStorage.getItem("zLawyerToken"));
    }, []);

    const logout = () => {
        localStorage.removeItem("zLawyerToken");
        localStorage.removeItem("zLawyerDemande");
        localStorage.removeItem("zLawyerIdUtilisateur");
        window.location.reload();
    };

    return (
        <section className={styles.footer}>
            <Link className={styles.link} href="https://help-web.zlawyer.fr/complement-word/">
                Comment utiliser le complément ?
            </Link>
            <h5>Version 2026.11.03.1</h5>

            {estConnecte && <div>
                <Button onClick={logout}>Déconnexion</Button>
            </div>}
        </section>
    );
};

export default Header;
